module.exports = __webpack_public_path__ + "img/mobile/BetBar/Home_button@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/Home_button@1x.png
// module id = 593
// module chunks = 0